import { render } from "./CajasList.vue?vue&type=template&id=f539afc4&scoped=true"
import script from "./CajasList.vue?vue&type=script&lang=js"
export * from "./CajasList.vue?vue&type=script&lang=js"

import "./CajasList.vue?vue&type=style&index=0&id=f539afc4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f539afc4"]])

export default __exports__